import Vue from 'vue'
import Router from 'vue-router'
import bottomMenu from "./components/bottomMenu"
const index = () => import('@/views/index/index.vue')
const userCenter = () => import('@/views/index/userCenter.vue')
const login = () => import('@/views/login/login.vue')
const school = () => import('@/views/index/school.vue')
const schoolList = () => import('@/views/school/schoolList.vue')
Vue.use(Router)

const router= new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'index',
            component: index,
            meta: {
                requireAuth: true,
                keepAlive: true
            }
        },
        // 首页新闻页
        {
            path: '/index/indexNews',
            name: 'indexNews',
            component: () => import('@/views/index/indexNews.vue')
        },
        // 首页新闻早班车
        {
            path: '/index/indexcars',
            name: 'indexcars',
            component: () => import('@/views/index/indexcars.vue')
        },
        {
            path: '/bottomMenu',
            name: 'bottomMenu',
            component: bottomMenu,
        },
        // 登录
        {
            path: '/login',
            name: 'login',
            component: login,

        },
        // 注册
        {
            path: '/register',
            name: 'register',
            component: () => import('@/views/login/register.vue')
        },
        // 个人中心
        {
            path: '/userCenter',
            name: 'userCenter',
            component: userCenter,
            meta: {
                requireAuth: true,
                keepAlive: true
            }
        },
        // 个人中心的用户协议和服务协议
        {
            path: '/serve',
            name: 'serve',
            component: () => import('@/views/user/serve.vue'),
            meta: {
                requireAuth: true,
                keepAlive: true
            }
        },
        {
            path: '/school',
            name: 'school',
            component: school,
            meta: {
                requireAuth: true,
                keepAlive: true
            }
        },
        {
            path: '/schoolList',
            name: 'schoolList',
            component: schoolList,
        },
        {
            path: '/schoolDetail',
            name: 'schoolDetail',
            component: () => import('@/views/school/schoolDetail.vue')
        },
        {
            path: '/schoolVr',
            name: 'schoolVr',
            component: () => import(/* webpackChunkName: "schoolDetail" */ '@/views/school/schoolVr.vue')
        },
        {
            path: '/address',  //地址选择
            name: 'address',
            component: () => import('@/views/school/address.vue')
        },
        
        {
            path: '/ims',//群聊
            name: 'ims',
            component: () => import('@/views/indexFunction/ims/index.vue')
        },
        {
            path: '/studyCenter',//留学中心首页
            name: 'studyCenter',
            component: () => import('@/views/studyCenter/studyCenter.vue')
        },
        {
            path: '/studyCenter/bannerDetail',//留学中心banner详情
            name: 'bannerDetail',
            component: () => import('@/views/studyCenter/bannerDetail.vue')
        },
        {
            path: '/studyCenter/ListDetail',//留学中心列表
            name: 'ListDetail',
            component: () => import('@/views/studyCenter/ListDetail.vue')
        },
        {
            path: '/studyCenter/passageway',//留学中心留学通道
            name: 'passageway',
            component: () => import('@/views/studyCenter/passageway.vue')
        },
        {
            path: '/professional',//职业库
            name: 'professional',
            component: () => import('@/views/indexFunction/professional/professional.vue')
        },
        {
            path: '/professionalDetail',//职业库详情
            name: 'professionalDetail',
            component: () => import('@/views/indexFunction/professional/professionalDetail.vue')
        },
        {
            path: '/shezhao',//高职社招
            name: 'shezhao',
            component: () => import('@/views/indexFunction/shezhao/shezhao.vue')
        },
        {
            path: '/shezhao/detail',//高职社招学校详情
            name: 'detail',
            component: () => import('@/views/indexFunction/shezhao/detail.vue')
        },
        {
            path: '/shezhao/headDetail',//高职社招头条详情
            name: 'headDetail',
            component: () => import('@/views/indexFunction/shezhao/headDetail.vue')
        },
        {
            path: '/benke',//本科优选
            name: 'benke',
            component: () => import('@/views/indexFunction/optimization/benke/benke.vue')
        },
        {
            path: '/bzNewsDetail',//本科优选咨询详情
            name: '/bzNewsDetail',
            component: () => import('@/views/indexFunction/optimization//bzNewsDetail.vue') 
        },
        {
            path: '/schoolSelectDetail',//专科优选学校详情
            name: 'schoolSelectDetail',
            component: () => import('@/views/indexFunction/optimization/public/schoolDetail.vue')
        },
        {
            path: '/xiaokuang/xiaokuang',//专科优选学校概况
            name: 'schoolinfo',
            component: () => import('@/views/indexFunction/optimization/public/schoolInfo.vue')
        },
        {
            path: '/zhaoxin/zhaoxin',//专科优选招生信息
            name: 'zhaosheng',
            component: () => import('@/views/indexFunction/optimization/public/zhaosheng.vue')
        },
        {
            path: '/zhaoxin/zhaoxinDetail',//专科优选招生简章详情
            name: 'zhaoshengDetail',
            component: () => import('@/views/indexFunction/optimization/public/zhaoshengDetail.vue')
        },
        {
            path: '/yuanzhuan/yuanzhuan',//专科优选院系和专业
            name: 'college',
            component: () => import('@/views/indexFunction/optimization/public/college.vue')
        },
        {
            path: '/yuanzhuan/collegeDetail',//专科优选院系和专业详情
            name: 'collegeDetail',
            component: () => import('@/views/indexFunction/optimization/public/collegeDetail.vue')
        },
        {
            path: '/yuanzhuan/majorDetail',//专科优选院系和专业详情
            name: 'majorDetail',
            component: () => import('@/views/indexFunction/optimization/public/majorDetail.vue')
        },
        {
            path: '/video/video',//专科优选视频
            name: 'schoolvideo',
            component: () => import('@/views/indexFunction/optimization/public/schoolVideo.vue')
        },
        {
            path: '/xiaoyuan/xiaoyuan',//校园风光
            name: 'schoolscenery',
            component: () => import('@/views/indexFunction/optimization/public/schoolScenery.vue')
        },
        {
            path: '/jiangli/jiangli',//专科优选奖励政策
            name: 'schoolreward',
            component: () => import('@/views/indexFunction/optimization/public/schoolReward.vue')
        },
        {
            path: '/student/student',//专科优选迎接新生
            name: 'schoolnew',
            component: () => import('@/views/indexFunction/optimization/public/schoolNew.vue')
        },
        {
            path: '/news/newsDetail',//专科优选迎接新生详情
            name: 'newsDetail',
            component: () => import('@/views/indexFunction/optimization/public/newsDetail.vue')
        },
        {
            path: '/news/news',//专科优选新闻中心
            name: 'schoolNews',
            component: () => import('@/views/indexFunction/optimization/public/schoolNews.vue')
        },
        {
            path: '/news/centerDetail',//专科优选新闻中心
            name: 'centerDetail',
            component: () => import('@/views/indexFunction/optimization/public/centerDetail.vue')
        },

        {
            path: '/pages/tabBar/school/scores/scores',//专科优选历年分数
            name: 'schoolscore',
            component: () => import('@/views/indexFunction/optimization/public/schoolScore.vue')
        },

        {
            path: '/webview/webview',//专科优选vr全景校园
            name: 'webview',
            component: () => import('@/views/indexFunction/optimization/public/webview.vue')
        },
        {
            path: '/zhuanke',//专科优选
            name: 'zhuanke',
            component: () => import('@/views/indexFunction/optimization/zhuanke/zhuanke.vue')
        },
        {
            path: '/career',//职业库
            name: 'career',
            component: () => import('@/views/indexFunction/career/career.vue')
        },
        {
            path: '/careerDetail',//职业库详情
            name: 'careerDetail',
            component: () => import('@/views/indexFunction/career/careerDetail.vue')
        },
        {
            path: '/probability',//录取概率
            name: 'probability',
            meta: {
                requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
            },
            component: () => import('@/views/indexFunction/probability/probability.vue')
        },
        {
            path: '/probabilityList',//录取概率院校
            name: 'probabilityList',
            component: () => import('@/views/indexFunction/probability/probabilityList.vue')
        },
        {
            path: '/fenlei',//分类招生
            name: 'fenlei',
            component: () => import('@/views/fenlei/index.vue')
        },
        {
            path: '/fenlei/search',//分类招生搜索
            name: 'fenleiSearch',
            component: () => import('@/views/fenlei/search/search.vue')
        },
        {
            path: '/fenlei/allSchool',//分类招生全部院校
            name: 'fenleiAllSchool',
            component: () => import('@/views/fenlei/allSchool/allSchool.vue')
        },
        {
            path: '/fenlei/policy',//分类招生报考政策
            name: 'policy',
            component: () => import('@/views/fenlei/policy/policy.vue')
        },
        {
            path: '/fenlei/policyDetail',//分类招生报考政策详情
            name: 'policyDetail',
            component: () => import('@/views/fenlei/policyDetail/policyDetail.vue')
        },
        {
            path: '/fenlei/hostSubject',//分类招生热门专业
            name: 'hostSubject',
            component: () => import('@/views/fenlei/hostSubject/hostSubject.vue')
        },
        {
            path: '/fenlei/openSchool',//分类招生热门专业开设院校
            name: 'openSchool',
            component: () => import('@/views/fenlei/openSchool/openSchool.vue')
        },
        {
            path: '/fenlei/historySubject',//分类招生历年真题
            name: 'historySubject',
            component: () => import('@/views/fenlei/historySubject/historySubject.vue')
        },
        {
            path: '/fenlei/subjectDetail',//分类招生历年真题详情
            name: 'subjectDetail',
            component: () => import('@/views/fenlei/subjectDetail/subjectDetail.vue')
        },
        {
            path: '/fenlei/schoolSubjectLIst',//分类招生历年真题学校题目列表
            name: ' schoolSubjectLIst',
            component: () => import('@/views/fenlei/schoolSubjectLIst/schoolSubjectLIst.vue')
        },
        {
            path: '/fenlei/schoolSubjectDetail',//分类招生历年真题学校题目详情
            name: ' schoolSubjectDetail',
            component: () => import('@/views/fenlei/schoolSubjectDetail/schoolSubjectDetail.vue')
        },
        {
            path: '/fenlei/historySchool',//进入历年分数学校列表
            name: ' historySchool',
            component: () => import('@/views/fenlei/historySchool/historySchool.vue')
        },
        {
            path: '/fenlei/historyDetail',//进入历年分数详情
            name: ' historyDetail',
            component: () => import('@/views/fenlei/historyDetail/historyDetail.vue')
        },
        {
            path: '/fenlei/HostDetail',//进入热门院校详情
            name: ' HostDetail',
            component: () => import('@/views/fenlei/HostDetail/HostDetail.vue')
        },
        {
            path: '/fenlei/generalRules',//进入院校招生简章列表
            name: ' generalRules',
            component: () => import('@/views/fenlei/generalRules/generalRules.vue')
        },
        {
            path: '/fenlei/generalRules/rulseDetail',//进入院校招生简章列表详情
            name: ' rulseDetail',
            component: () => import('@/views/fenlei/generalRules/rulseDetail/rulseDetail.vue')
        },
        {
            path: '/fenlei/HostDetail/professional',//进入热门院校专业介绍
            name: ' professional',
            component: () => import('@/views/fenlei/HostDetail/professional/professional.vue')
        },
        {
            path: '/fenlei/HostDetail/itemBank',//进入热门院校校考题库列表
            name: ' itemBank',
            component: () => import('@/views/fenlei/HostDetail/itemBank/itemBank.vue')
        },
        {
            path: '/fenlei/HostDetail/allDetail',//进入热门院校介绍
            name: ' allDetail',
            component: () => import('@/views/fenlei/HostDetail/allDetail/allDetail.vue')
        },
        {
            path: '/fenlei/HostDetail/scienceDetail',//进入热门院校校园环境
            name: ' scienceDetail',
            component: () => import('@/views/fenlei/HostDetail/scienceDetail/scienceDetail.vue')
        },
        {
            path: '/contrast',//对比校
            name: 'contrast',
            component: () => import('@/views/indexFunction/probability/contrast.vue')
        },
        {
            path: '/newsDetail',//新闻页
            name: 'newsDetail',
            component: () => import('@/views/news/newsDetail.vue')
        },
        {
            path: '/videoDetail',//视频页
            name: 'videoDetail',
            component: () => import('@/views/news/videoDetail.vue')
        },
        {
            path: '/writeComment',//写留言
            name: 'writeComment',
            component: () => import('@/views/news/writeComment.vue')
        },
        {
            path: '/collection',//我的收藏
            name: 'collection',
            component: () => import('@/views/user/collection.vue')
        },
        {
            path: '/about',//关于校派
            name: 'about',
            component: () => import('@/views/user/about.vue')
        },
        {
            path: '/bindPhone',//关于校派
            name: 'bindPhone',
            component: () => import('@/views/user/bindPhone.vue')
        },
        {
            path: '/zhiyuandan',//志愿单
            name: 'zhiyuandan',
            component: () => import('@/views/user/zhiyuandan.vue')
        }
        
    ]
})

export default  router;
